var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCallAudio = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.05222V14.3856H4.88889L11 20.4967V0.941111L4.88889 7.05222H0ZM16.5 10.7189C16.5 8.55556 15.2533 6.69778 13.4444 5.79333V15.6322C15.2533 14.74 16.5 12.8822 16.5 10.7189ZM13.4444 0V2.51778C16.9767 3.56889 19.5556 6.84444 19.5556 10.7189C19.5556 14.5933 16.9767 17.8689 13.4444 18.92V21.4378C18.3456 20.3256 22 15.95 22 10.7189C22 5.48778 18.3456 1.11222 13.4444 0Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCallAudio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_call_audio.5975f4785edf88b89c855841b8d482a8.svg";